<div class="login-page">
    <div class="login-dot" #seasonBackground aria-hidden="true"></div>
    <div class="login-veil" aria-hidden="true"></div>

    <section class="login-brand">
        <div class="brand-inner">
            <mat-icon svgIcon="icon_logo" class="brand-logo"></mat-icon>
            <span class="brand-rule" aria-hidden="true"></span>
            <p class="brand-title">Il tuo interprete, quando ti serve.</p>
            <p class="brand-tagline">
                Richiedi un interprete, segui le tue richieste e consulta i tuoi
                appuntamenti.
            </p>
        </div>
    </section>

    <section class="login-panel">
        <div class="login-card">
            <span class="card-glow" aria-hidden="true"></span>

            <div class="login-mobile-brand">
                <mat-icon svgIcon="icon_logo" class="mobile-logo"></mat-icon>
            </div>

            <header class="login-head">
                <p class="login-eyebrow">Accesso utenti</p>
                <h1 class="login-title">Accedi</h1>
                <p class="login-sub">
                    Entra per richiedere un interprete o consultare i tuoi
                    appuntamenti.
                </p>
            </header>

            <form
                (ngSubmit)="onYesClick()"
                [formGroup]="formGroup"
                class="login-form"
                novalidate
            >
                <mat-form-field class="fo-field login-field">
                    <mat-label>Nome utente</mat-label>
                    <input
                        matInput
                        type="text"
                        formControlName="username"
                        autocomplete="username"
                        required
                    />
                    <mat-icon matSuffix>perm_identity</mat-icon>
                    <mat-error
                        *ngIf="
                            formGroup.controls['username'].hasError('required')
                        "
                        >Inserisci il nome utente</mat-error
                    >
                </mat-form-field>

                <mat-form-field class="fo-field login-field">
                    <mat-label>Password</mat-label>
                    <input
                        matInput
                        type="password"
                        formControlName="password"
                        autocomplete="current-password"
                        required
                    />
                    <mat-icon matSuffix>vpn_key</mat-icon>
                    <mat-error
                        *ngIf="
                            formGroup.controls['password'].hasError('required')
                        "
                        >Inserisci la password</mat-error
                    >
                </mat-form-field>

                <button
                    type="submit"
                    class="fo-btn fo-btn--primary fo-btn--block login-submit"
                    [disabled]="!formGroup.valid"
                >
                    Accedi
                </button>
            </form>

            <div class="login-links">
                <a
                    (click)="Forgot()"
                    (keydown.enter)="Forgot()"
                    class="login-link"
                    tabindex="0"
                    >Hai dimenticato la password?</a
                >
                <p *ngIf="showSingUp" class="login-signup">
                    Non hai un account?
                    <a
                        (click)="Registration()"
                        (keydown.enter)="Registration()"
                        class="login-link"
                        tabindex="0"
                        >Registrati</a
                    >
                </p>
            </div>
        </div>
    </section>
</div>
